import { SVGProps, Ref, forwardRef } from 'react';

export const YandexCloudBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M12 23c-2.733-.066-3.816-1.893-4.146-3.658-.18-.96-.1-2.554 0-3.124.164-.928.428-2.261.72-3.809.419-2.218 1.53-3.479 3.926-3.929l3.92-.749c.105-.582.301-2.123.122-3.073-.333-1.783-1.708-3.63-4.498-3.658C5.967 1 1 5.923 1 12s4.923 11 11 11"
            fill="#9EB9FF"
        />
        <path
            d="M12 1c2.733.066 4.086 1.897 4.416 3.661.18.96-.17 2.551-.27 3.12-.164.929-.428 2.263-.72 3.81-.42 2.218-1.53 3.48-3.926 3.929l-3.649.716c-.104.582-.447 2.155-.267 3.105.333 1.783 1.582 3.63 4.372 3.66C18.033 23 23 18.076 23 12S18.077 1 12 1"
            fill="#5282FF"
        />
        <path
            d="M16.145 7.783c-.164.928-.427 2.261-.72 3.808-.418 2.218-1.529 3.48-3.926 3.929l-3.648.715.003-.017c.164-.928.428-2.261.72-3.81.419-2.217 1.53-3.478 3.926-3.928z"
            fill="white"
        />
    </svg>
));
YandexCloudBrandSize24Glyph.displayName = 'YandexCloudBrandSize24Glyph';
